import { EpiBlock } from '@api/types';
import { BlockContainer, BrandSliderPlaceholder, Title } from '@components';
import { EditPanel } from '@components/edit-mode';
import { Box, styled } from '@mui/material';
import { colors } from '@themes/colors';
import { breakpoints } from '@themes/theme.helpers';
import { lazy, Suspense } from 'react';

const BrandSlider = lazy(() =>
  import('@components').then((module) => ({ default: module.BrandSlider }))
);

const StyledBrandGrid = styled(Box)`
  ${breakpoints.up('lmd')} {
    display: grid;
    grid-template-columns: 30% 70%;
    gap: 20px;
  }

  ${breakpoints.up('xl')} {
    grid-template-columns: 25% 75%;
  }
  align-items: center;
`;

type BrandBlockProps = {
  text?: string;
  content?: EpiBlock[];
  disableEditPanel?: boolean;
};

export const BrandBlock: React.FC<BrandBlockProps> = ({
  text,
  content,
  disableEditPanel = false,
}: BrandBlockProps) => {
  const references = content
    ?.map((x) => x?.contentLink?.id)
    .filter((x) => x !== undefined) as number[];

  const Block = <EditPanel disableEditPanel={disableEditPanel} properties={['content', 'text']} />;
  return (
    <Box
      className='brand-block'
      sx={{
        backgroundColor: colors.background.white,
      }}
    >
      {Block}

      <BlockContainer>
        <StyledBrandGrid>
          <Title
            variant='h3'
            noDot
            sx={{
              textWrap: 'balance',
              fontWeight: '500 !important',
              textAlign: { xs: 'center', lmd: 'left' },
              mt: {
                xs: '24px',
                lmd: '0px',
              },
            }}
          >
            {text}
          </Title>
          <Box
            sx={{
              mr: {
                xs: '0px',
                lmd: '24px',
              },
            }}
          >
            <Suspense fallback={<BrandSliderPlaceholder references={references} />}>
              <BrandSlider references={references} />
            </Suspense>
          </Box>
        </StyledBrandGrid>
      </BlockContainer>
    </Box>
  );
};
